import { render, staticRenderFns } from "./InvoiceDates.vue?vue&type=template&id=63724bcc&"
import script from "./InvoiceDates.vue?vue&type=script&lang=js&"
export * from "./InvoiceDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports